import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RuAvailabilityValidateService {

	constructor(private http: HttpClient) {}

	validateAvailability(data: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(
			`${environment.apiUrl}/rentals-united/availabilities/validate`,
			data
		);
	}
}
